import { JSX } from 'react';
import { type IAtTextInputProps } from './at-text-input.types';
import classNames from 'classnames';

export const AtTextInput = ({
  id,
  label,
  disabled = false,
  placeholder,
  className,
  error = '',
  value,
  onChange,
  type = 'text',
  ...rest
}: IAtTextInputProps): JSX.Element => {
  const hasError = error?.length > 0;

  return (
    <div className="relative flex w-full flex-col">
      {label && (
        <label
          htmlFor={id}
          className={classNames(
            'absolute -top-3 left-4 bg-skin-primary px-1 text-10 text-page-link md:-top-[0.75rem] md:text-sm',
            hasError && 'text-skin-error',
          )}
        >
          {label}
        </label>
      )}

      <input
        id={id}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        onChange={onChange}
        type={type}
        className={classNames(
          'h-10 w-full rounded-15 border-2 bg-transparent px-4 focus:outline-none md:h-[3.938rem]',
          hasError
            ? 'border-skin-error'
            : 'border-skin-stroke-secondary md:border-skin-stroke-primary',
          className,
        )}
        {...(hasError
          ? {
              'aria-invalid': true as const,
              'aria-describedby': `errorMessage-${id}`,
            }
          : {})}
        {...rest}
      />

      {hasError && (
        <p
          className="mt-2 pl-4 text-xs text-skin-alert"
          id={`errorMessage-${id}`}
          role="alert"
        >
          {error}
        </p>
      )}
    </div>
  );
};
